import styled from 'styled-components';

import { AnimatedNumber } from 'atoms/animations/AnimatedNumber';
import { ButtonBase } from 'atoms/buttons/ButtonBase';
import { GemIcon } from 'atoms/icons/GemIcon';
import { Horizontal } from 'atoms/layout/flex';
import { LabelM } from 'atoms/typography';
import { DialogKey } from 'components/navigation/WithDialogs';
import { useOpenDialog } from 'hooks/navigation/useOpenDialog';
import { useEvents } from 'lib/events/useEvents';
import { OpenBuyGemsDialog_Context } from 'protos/events/platform/web/events';

const IconWrapper = styled(Horizontal).attrs({ center: true })`
  width: var(--triple-unit);
  height: var(--triple-unit);
  border-radius: 50%;
  background: var(--c-nd-150);

  & > img {
    height: 16px;
    object-fit: contain;
  }
`;

const Root = styled(ButtonBase)`
  border-radius: var(--double-unit);
  padding-left: var(--unit);
  background: var(--c-nd-50);
  display: flex;
  &:hover {
    background: var(--c-nd-100);
  }
`;

type Props = { balance: number };
export const GemsBalance = ({ balance }: Props) => {
  const track = useEvents();
  const openDialog = useOpenDialog();

  return (
    <Root
      onClick={() => {
        track('Open Buy Gems Dialog', {
          context: OpenBuyGemsDialog_Context.GEMS_BALANCE,
        });
        openDialog(DialogKey.buyGems, 'true');
      }}
    >
      <Horizontal gap={0.5}>
        <LabelM bold>
          <AnimatedNumber value={balance} disableAnimationOnFirstRender />
        </LabelM>
        <IconWrapper>
          <GemIcon />
        </IconWrapper>
      </Horizontal>
    </Root>
  );
};
